import MuiBox, { BoxProps as MuiBoxProps } from '@mui/material/Box';
import * as React from 'react';

export interface BoxProps extends MuiBoxProps {
  component?: React.ElementType;
}

export const Box = (props: BoxProps) => {
  return <MuiBox {...props} />;
};
